import { useMutation, useQueryClient } from '@tanstack/react-query';
import { authServices } from '../services/auth.service';
import toast from 'react-hot-toast';

export const usePasswordChange = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: authServices.changePassword,
    onSuccess: (data) => {
      queryClient.invalidateQueries(['user-profile']);
      toast.success(data?.message || 'Password updated');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update password');
    },
  });
};
